<template>
<div class="chapter">
<div class="inner_page">
<div class="pg-boilerplate" id="pgepubid00008">
<h2 class="calibre11" id="calibre_pb_0">CHRONOLOGICAL TABLE</h2>
</div>
<table border="0" cellpadding="5" cellspacing="0" class="calibre12" summary="Chronology">
<colgroup class="calibre13"><col class="calibre20"/>
<col class="calibre20"/>
</colgroup>
<tbody class="calibre16"><tr class="calibre17">
<th class="tdct">Christopher Carson</th>
<th class="tdct">John Charles Frémont</th>
</tr>
<tr class="calibre17">
<td class="tdlt">Born Madison County, Ky., December 25, 1809.</td>
<td class="tdlt">January 21, 1813, born at Savannah, Ga.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Father: Lindsay (Linsey) Carson, of North Carolina and Kentucky.</td>
<td class="tdlt">Father: John Charles Frémont, of France and of Virginia.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Mother: Rebecca Robinson, of Virginia.</td>
<td class="tdlt">Mother: Anne Beverley Pryor, of Virginia.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Reared without education, on the Missouri frontier.</td>
<td class="tdlt">Educated by tutor and college at Charleston, S. Carolina.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Apprenticed to a harness-maker at Franklin, Mo.—1825.</td>
<td class="tdlt">1833–1836—Teacher of Mathematics to Midshipmen on Sloop-of-War Natchez.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">On the Santa Fé Trail at Fifteen—1826.</td>
<td class="tdlt">1836—Commissioned Professor of Mathematics in the Navy, Assigned to
the Frigate Independence.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Interpreter and Teamster, in New Mexico and Old Mexico—1827–1829.</td>
<td class="tdlt">1837–1838—Railroad and Army Surveyor.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Trapper to California—1829–1830.</td>
<td class="tdlt">1838—Commissioned Second Lieutenant, Topographical Engineers, U. S. A.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Rocky Mountain Trapper—1830–1838.</td>
<td class="tdlt">1838–1839—Government Survey of Upper Mississippi River, under J. N. Nicollet.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Married an Arapahoe Indian girl—1835.</td>
<td class="tdlt"><span id="pgepubid00009" title="[14]"><a id="Page_14" title="[14]"></a></span>1841—Married
Jessie Benton of Washington.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Hunter and Captain of Trappers, at Bent’s Fort and Taos—1838–1842.</td>
<td class="tdlt">1841—Survey of Lower Des Moines River.</td>
</tr>
<tr class="calibre17">
<td class="tdlt"> Hunter with the Frémont First Expedition—1842.</td>
<td class="tdlt">1842—First Government Exploring Expedition, to the South Pass and
Frémont’s Peak.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Married Josefa Jaramillo of Taos—1843.</td>
<td class="tdlt">1843–1844—Second Government Exploring Expedition, to the Salt Lake, to the Columbia,
south through California, back by the Spanish Trail and the Rocky Mountains.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Hunter and General Assistant with Frémont Second Expedition—1843–1844.</td>
<td class="tdlt">1845—Promoted by brevet to First Lieutenant and Captain.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Goes to Ranching in New Mexico—1845.</td>
<td class="tdlt">1845–1846—Third Government Exploring Expedition, across the Great Basin into
Northern California.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Guide and General Assistant with the Frémont Third Expedition—1845–1846.</td>
<td class="tdlt">1846—As Major Commands a Battalion for the Conquest of California.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Scout and Express Bearer under Colonel Frémont, Commodore Stockton and General
Kearny, in the Conquest of California—1846.</td>
<td class="tdlt">1846–1847—Military Commander and Governor of California.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Express Service with Despatches Across the Continent to Washington—1847–1848.</td>
<td class="tdlt">1846—Promoted to Lieutenant-Colonel of Mounted Rifles, U. S. A.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Commissioned Second Lieutenant of Mounted Rifles, U. S. A., but the Commission
not confirmed—1847.</td>
<td class="tdlt"><span id="pgepubid00010" title="[15]"><a id="Page_15" title="[15]"></a></span>1847–1848—Court-martialed
at Washington for Insubordination, Found Guilty, but Recommended for Leniency.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Serves on Outpost Duty in California—1847.</td>
<td class="tdlt">1848—Resigns from Army.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">His Express Duty of 1848 Completed, Becomes Private Citizen at Taos—1848.</td>
<td class="tdlt">1848–1849—Fourth Exploring Expedition, into the Southern Colorado Mountains; thence
Forced Back, and to California by a Southern Route.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Seeks ranch life in New Mexico—1849–1850.</td>
<td class="tdlt">1849–1850—Seeks ranch life in California.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Scout Duty against the Indians, with Army Detachments—1850.</td>
<td class="tdlt">1850–1851—Senator from California.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Overland to California with a Drove of 30,000 sheep—1853.</td>
<td class="tdlt">1851–1853—California and Europe.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Government Indian Agent over Utes and Apaches, Quarters at Taos—1854–1860.</td>
<td class="tdlt">1853–1854—Fifth Exploring Expedition, across the Great Basin of Utah and Nevada
to California.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Scout Duty against the Indians, with Army Detachments—1854–1855.</td>
<td class="tdlt">1856—Nominated by the Republican Party for the Presidency. Defeated by Buchanan.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Lieutenant-Colonel and Colonel, First New Mexican Infantry, U. S. Vols.—1861–1862.</td>
<td class="tdlt">1861—Major-General, Department of the West, U. S. A., headquarters at St. Louis.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Colonel of First New Mexican Cavalry, U. S. Vols., conducting campaigns against
the Apaches, Navajos and Kiowas, New Mexico and Arizona—1862–1864.</td>
<td class="tdlt">1862—Resigns from Army, after service in Command of the Mountain Department of Virginia,
Tennessee and Kentucky.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Military Service on the Santa Fé Trail and Special Commissioner to treat with Cheyennes
and Arapahoes—1865.</td>
<td class="tdlt"><span id="pgepubid00011" title="[16]"><a id="Page_16" title="[16]"></a></span>1864—Nominated
for Presidency. Withdraws.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Lieutenant-Colonel (Brigadier General by Brevet, for Distinguished Service) in command
at Fort Garland, Colorado—1866–1867.</td>
<td class="tdlt">1866–1878—Railroad Construction, etc.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Resigned from the Army, on Account of Ill Health—1867.</td>
<td class="tdlt">1878–1882—Governor of Arizona.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Special Commissioner to Treat with the Utes, at Washington—1868.</td>
<td class="tdlt">1890—Appointed Major-General, on the Retired List.</td>
</tr>
<tr class="calibre17">
<td class="tdlt">Died at New Fort Lyon, Colorado, May 23, 1868.</td>
<td class="tdlt">July 13, 1890, died in New York City.</td>
</tr>
</tbody>
</table>
<p class="calibre8"><span id="pgepubid00012" title="[17]"><a id="Page_17" title="[17]"></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0006.vue?2617fbc0